exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".intro-header{font-size:30px;margin-top:30px;color:var(--primary-color)}.intro-header-sub{font-size:18px;color:var(--primary-color)}.intro-content{line-height:1.8em}.intro-header-sub-center{font-weight:bold;font-size:18px;color:var(--primary-color);text-align:center;margin-bottom:15px}.intro-icon{cursor:pointer;width:90px}.sub-image{width:100%}.sub-image-header{background-color:orange;color:white;position:absolute;width:100%;padding:3%;opacity:0.9;font-size:1em}.sub-image-container{position:relative}.sub-text-container{margin-right:10%}.sub-logo{max-width:100%}.sub-title{font-size:1.5em;margin-top:2em;font-weight:bold}.sub-content{text-align:justify;font-size:1em;margin-top:1em}.background-box{background-image:url(/images/intro-background.png);background-position:center;background-repeat:no-repeat;padding:5% 3% 3% 3%;margin-top:20px;margin-left:0 !important;margin-right:0 !important}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/portal_homeowner/intro.scss
// module id = 2030
// module chunks = 35